import Vue from 'vue'
import App from './App.vue'
import router from './router'
import '@/styles/common.less'
import head from './components/head'
import indexTitle from './components/indexTitle'
import footer from './components/footer'
import header from './components/header'
import '@fortawesome/fontawesome-free/css/all.min.css'
import '@/styles/responsive.less'
import '@/styles/mobile.less'

Vue.component('headIndex', head)
Vue.component('indexTitle', indexTitle)
Vue.component('footerIndex', footer)
Vue.component('headerIndex', header)
Vue.config.productionTip = false
// $baseUrl 用于图片等静态资源路径
// 开发时走 vue devServer proxy，用空字符串
// 生产/Live Server 时用 .env.production 中的 VUE_APP_API_BASE
Vue.prototype.$baseUrl = process.env.VUE_APP_API_BASE || ''
// Vue.prototype.$baseUrl = 'http://192.168.31.29:8080'
// Vue.prototype.$baseUrl = 'https://nonfictively-nonfermentable-demarcus.ngrok-free.dev'

Vue.config.errorHandler = function (err) {
  console.error('Application error:', err)
}

window.addEventListener('unhandledrejection', event => {
  console.error('Unhandled async error:', event.reason)
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
